import React from "react";
import { useNavigate } from "react-router-dom";

const InviteCard = ({ type, invite, userProfile, onAccept, onPass, project }) => {
  const { projectId, roleId, status } = invite;
  const navigate = useNavigate();
  console.log("🔍 openRoles", project?.project?.openRoles);
  console.log("🔍 roleId", roleId);

    const openRoles = project?.project?.openRoles || [];

    const matchedRole =
        roleId && Array.isArray(openRoles)
        ? openRoles.find((r) => String(r.id) === String(roleId))
        : null;

    const roleTitle = matchedRole?.roleTitle || (roleId ? "Custom Role" : "None assigned");

    const projectTitle = project?.project?.title || "Untitled Project";

    const handleUserClick = () => {
        if (!userProfile?.email) return;
        const username = userProfile.email.split("@")[0];
        navigate(`/${username}`);
    };

    const handleProjectClick = () => {
        if (!projectId) return;
        navigate(`/projects/${projectId}/details`);
    };


    return (
    <div className="bg-black text-white border border-white rounded-xl p-4 shadow-sm w-full mb-4 flex justify-between gap-4 items-start">
      {/* LEFT SIDE */}
      <div className="flex-1">
        {/* Header */}
        <div className="flex items-center gap-3 mb-3">
          <div onClick={handleUserClick} className="cursor-pointer">
            {userProfile?.profileImage ? (
              <img
                src={userProfile.profileImage}
                alt="avatar"
                className="w-10 h-10 rounded-full object-cover border border-white"
              />
            ) : (
              <div className="w-10 h-10 rounded-full bg-white text-black font-semibold flex items-center justify-center">
                {userProfile?.firstName?.[0] || "?"}
              </div>
            )}
          </div>
          <div onClick={handleUserClick} className="leading-tight cursor-pointer">
            <div className="text-sm tracking-wide text-gray-300 uppercase">
              {type === "sent" ? "Sent To" : "From"}
            </div>
            <div className="text-base font-medium">
              {userProfile?.firstName} {userProfile?.lastName}
            </div>
          </div>
        </div>

        {/* Info */}
        <div className="mb-2">
          <div className="text-xs text-gray-400 uppercase tracking-wider">Project</div>
          <div
            className="text-sm font-semibold cursor-pointer hover:underline"
            onClick={handleProjectClick}
          >
            {projectTitle}
          </div>
        </div>

        <div className="mb-2">
          <div className="text-xs text-gray-400 uppercase tracking-wider">Role</div>
          <div className="text-sm font-medium">{roleTitle}</div>
        </div>

        <div className="mb-3">
          <div className="text-xs text-gray-400 uppercase tracking-wider">Status</div>
          <div
            className={`text-sm font-semibold ${
              status === "pending"
                ? "text-yellow-400"
                : status === "connected"
                ? "text-green-400"
                : "text-gray-400"
            }`}
          >
            {status}
          </div>
        </div>

        {/* Buttons */}
        {type === "received" && status === "pending" && (
          <div className="flex gap-3 mt-3">
            <button
              onClick={() => onAccept(invite)}
              className="px-3 py-1.5 bg-white text-black text-xs font-semibold rounded-full hover:bg-gray-200 transition"
            >
              Accept
            </button>
            <button
              onClick={() => onPass(invite)}
              className="px-3 py-1.5 border border-white text-white text-xs font-medium rounded-full hover:bg-white hover:text-black transition"
            >
              Pass
            </button>
          </div>
        )}
      </div>

        {/* RIGHT SIDE: Project Image */}
        {project?.project?.image && (
            <div
                className="w-[120px] h-[120px] rounded-xl overflow-hidden border-2 border-white shadow-md cursor-pointer hover:scale-105 transition-transform self-center"
                onClick={handleProjectClick}
            >
                <img
                    src={project.project.image}
                    alt="project"
                    className="w-full h-full object-cover"
                />
            </div>
        )}

    </div>
  );

};

export default InviteCard;
